
import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import DeleteSelectedNodesOperation from "models/audioEditor/sequencerOperation/DeleteSelectedNodesOperation";
import RSVP from "rsvp";


const RevertDeleteSelectedNodesOperation =  DeleteSelectedNodesOperation.extend({
    idAttribute: "id",


    constructor: function(attributes, options) {
        DeleteSelectedNodesOperation.apply(this, [attributes, options]);
    },

    execute : function(deletedSequencerNode){
        const arrayOfNodeReplaced = deletedSequencerNode.getArrayOfNodeReplaced();
        // If the deleted node has already been reverted (e.g. a duplicate restore click, or a
        // nested revert from a parent ReplacementSequencerNode), arrayOfNodeReplaced is null or
        // empty. Logging a DeleteDeleteNodesLog with null would corrupt undo/redo — on replay,
        // DeleteSelectedNodesOperation.redo() calls replaceNodes(null).filter() and crashes.
        if(!arrayOfNodeReplaced || arrayOfNodeReplaced.length === 0){
            console.warn("RevertDeleteSelectedNodesOperation.execute: deleted node has nothing to revert (already reverted?)", {
                cid: deletedSequencerNode && deletedSequencerNode.cid
            });
            return;
        }
        this.revertReplacement(deletedSequencerNode);
        this.getSequencer().getHistoryManagement().addDeleteNodeDeletedLog(arrayOfNodeReplaced, deletedSequencerNode);

    },

    
    undo : function(sequencerOperationDeleteDeleteNodesLog ){
        return DeleteSelectedNodesOperation.prototype.redo.apply(this, [sequencerOperationDeleteDeleteNodesLog]);
    },

    redo: function(sequencerOperationDeleteDeleteNodesLog){
        return DeleteSelectedNodesOperation.prototype.undo.apply(this, [sequencerOperationDeleteDeleteNodesLog]);
    },

});


export default RevertDeleteSelectedNodesOperation; 